export default [
  {
    name: 'timeline-banners',
    path: '/timeline-banners',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Timeline Banners',
      icon: 'dvr',
      label: 'Timeline Banners'
    }
  }
]
